export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14817.e0454f38.jpg";